import React from "react"
import { Link } from "react-router-dom";

const CheckupCard = ({ image, alt, ageRange, icon, gender, checkupID }) => {
  return (
    <Link
      to={'/recommended-checkups/' + gender + '-' + encodeURIComponent(ageRange.replace(/ /g, '-')) + '-' + checkupID}
    >
      <div className="bg-white rounded-2xl overflow-hidden hover:shadow-sm transition-shadow cursor-pointer border border-[#E0E0E0] hover:border-[#951C25]/30">
        <div className="relative h-28 md:h-[9rem]">
          <img src={image || "/placeholder.svg"} alt={alt} className="object-cover w-full h-full" />
        </div>
        <div className="p-3 flex items-center">
          <div className="w-6 h-6 rounded-full bg-[#951C25]/20 flex items-center justify-center mr-2">{icon}</div>
          <span className="text-sm font-medium text-[#4A4A4A]">{ageRange}</span>
        </div>
      </div>
    </Link>
  )
}

const CheckupSection = ({ title, gender, cards }) => {
  const icon =
    gender === "Men" ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="#951C25"
        stroke="#951C25"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="8" r="7"></circle>
        <polyline points="12 15 12 22"></polyline>
        <line x1="8" y1="18" x2="16" y2="18"></line>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="#951C25"
        stroke="#951C25"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="8" r="7"></circle>
        <line x1="12" y1="15" x2="12" y2="22"></line>
        <line x1="9" y1="19" x2="15" y2="19"></line>
        <line x1="12" y1="22" x2="12" y2="22"></line>
      </svg>
    )

  return (
    <section className={`py-10 md:py-14 ${gender === "Men" ? "bg-[#F5F5F7]" : "bg-white"}`}>
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-semibold text-[#4A4A4A] mb-2">
            {title} <span className="text-[#951C25]">{gender}</span>
          </h2>

          {gender !== "Kids" ? (
            <p className="text-[#4A4A4A]/70">Curated by Doctors for you</p>
          ) : (
            <p className="text-[#4A4A4A]/70">
              Ensure your child's health with age-appropriate vaccinations recommended by pediatricians
            </p>
          )}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {cards && cards.length > 0 && cards.map((card, index) => (
            <>
              <CheckupCard
                key={index}
                image={card.image}
                alt={card.alt}
                ageRange={card.ageRange}
                icon={icon}
                gender={gender}
                checkupID={card.id}
              />

            </>
          ))}

          {gender !== "Kids" && (
            <div className="bg-white rounded-2xl overflow-hidden hover:shadow-sm transition-shadow cursor-pointer flex flex-col items-center justify-center p-4 h-full border border-[#E0E0E0] hover:border-[#951C25]/30">
              <div className="w-8 h-8 rounded-full bg-[#951C25]/20 flex items-center justify-center mb-2">{icon}</div>
              <span className="text-sm font-medium text-[#4A4A4A] text-center">
                <Link
                  to={'/book-tests'}
                >
                  Find more <span className="text-[#951C25]">Packages</span>
                </Link>
              </span>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default CheckupSection
